module.exports = __webpack_public_path__ + "img/sms-new.25e46442.svg";